import InvestorRoutes from '../apps/investor/InvestorRoutes';
import AuthRoutes from '../apps/auth/AuthRoutes';
import { TAppRoutes } from './features/routes/types/TAppRoute';
import AdminRoutes from '../apps/admin/AdminRoutes';
import TestRoutes from '../apps/test/TestRoutes';
import FaqRoutes from '../apps/faq/FaqRoutes';
import HomeRoutes from '../apps/home/HomeRoutes';
import NewsRoutes from '../apps/news/NewsRoutes';
import DocumentRoutes from '../apps/document/DocumentRoutes';
import ContactsRoutes from '../apps/contacts/ContactsRoutes';

const AppRoutes = [
	HomeRoutes,
	AdminRoutes,
	DocumentRoutes,
	FaqRoutes,
	InvestorRoutes,
	AuthRoutes,
	NewsRoutes,
	ContactsRoutes,
	TestRoutes,
] as TAppRoutes[];

export default AppRoutes;
